import React from 'react';
import { Navigate } from 'react-router-dom';
import { Empty } from 'antd';
import { useAppSelector, useAuth } from '../store/hooks';
import { AppRoutes } from '../routes';

const HomeRedirect: React.FC = () => {
  const { claims } = useAuth();
  const selectedCompany = useAppSelector((state) => state.companies.selectedCompany);
  const companies = useAppSelector((state) => state.companies.companies);

  const companyAccess = claims?.companyAccess || {};
  const hasCompanyAccess = claims?.superadmin
    || (companyAccess['*'] ?? 0) >= 10
    || Object.values(companyAccess).some((lvl: any) => (typeof lvl === 'number' ? lvl : 0) >= 10)
    || companies.length > 0;

  const canSeeCustomProducts = selectedCompany?.modules?.customContent === true
    && (claims?.superadmin || hasCompanyAccess);
  const canSeeBrandResearch = selectedCompany?.modules?.brandResearch === true
    && (claims?.superadmin || hasCompanyAccess);

  const canSeeShopify = selectedCompany?.modules?.shopify === true
    && (claims?.superadmin || claims?.features?.featureShopify || hasCompanyAccess);

  if (canSeeCustomProducts) {
    return <Navigate to={AppRoutes.customProductGenerator} replace />;
  }

  if (canSeeBrandResearch) {
    return <Navigate to={AppRoutes.brandResearch} replace />;
  }

  if (canSeeShopify) {
    return <Navigate to={AppRoutes.shopify} replace />;
  }

  if (claims?.superadmin) {
    return <Navigate to={AppRoutes.adminCenter} replace />;
  }

  return (
    <div style={{ padding: 48 }}>
      <Empty description="Select a company to continue." />
    </div>
  );
};

export default HomeRedirect;
